import { render } from "./FirstRun.vue?vue&type=template&id=7b0c8aea&scoped=true"
import script from "./FirstRun.vue?vue&type=script&lang=js"
export * from "./FirstRun.vue?vue&type=script&lang=js"

import "./firstrun.css?vue&type=style&index=0&id=7b0c8aea&scoped=true&lang=css"

import exportComponent from "/home/node/site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b0c8aea"]])

export default __exports__